let env = 'T2'
const url = window.location.hostname

if (url.indexOf('promotion.noahgroup.com') >= 0) {
    env = 'pord'
} else if (url.indexOf('noah-live-t1') >= 0) {
    env = 'T1'
} else if (url.indexOf('noah-live-t2') >= 0) {
    env = 'T2'
} else if (url.indexOf('noah-live.noahgrouptest') >= 0) {
    env = 'T3'
} else if (url.indexOf('noah-live-t4') >= 0) {
    env = 'T4'
}

const envData = {
    pord: {
        env: 'pord',
        shangLiveDomin: 'https://smart-static.ifaclub.com/',
        imBaseUrl: "https://noah-live.ifaclub.com/chat-room",
        shareAppId: 'wxda7442837c95c16c',
        sensorsUrl: 'https://sensors-nds.noahgroup.com/sdkdata/sa?project=ppsczx_prod',
        wxWorkAppId: 'ww33c91e748f1f38e4',
        wxWorkAgentId: '1000013',
    },
    T1: {
        env: 'T1',
        shangLiveDomin: 'https://smart-static-t1.noahgrouptest.com/',
        imBaseUrl: "https://noah-live-t1.noahgrouptest.com/chat-room",
        shareAppId: 'wxa60d55511876a3e2',
        sensorsUrl: 'http://10.1.131.13:8106/sa',
        wxWorkAppId: 'ww33c91e748f1f38e4',
        wxWorkAgentId: '1000012',
    },
    T2: {
        env: 'T2',
        shangLiveDomin: 'https://smart-static-t2.noahgrouptest.com/',
        imBaseUrl: "https://noah-live-t2.ifaclub.com/chat-room",
        shareAppId: 'wx143dfc0ee4c921cb',
        sensorsUrl: 'http://10.1.131.13:8106/sa?project=ppsczx',
        wxWorkAppId: 'ww33c91e748f1f38e4',
        wxWorkAgentId: '1000012',
    },
    T3: {
        env: 'T3',
        shangLiveDomin: 'https://smart-static.noahgrouptest.com/',
        imBaseUrl: "https://noah-live.noahgrouptest.com/chat-room",
        shareAppId: 'wxda7442837c95c16c',
        sensorsUrl: 'http://10.1.131.13:8106/sa',
        wxWorkAppId: 'ww33c91e748f1f38e4',
        wxWorkAgentId: '1000012',
    },
    T4: {
        env: 'T4',
        shangLiveDomin: 'https://smart-static-t4.noahgrouptest.com/',
        imBaseUrl: "https://noah-live-t4.noahgrouptest.com/chat-room",
        shareAppId: 'wx6679012142b278d7',
        sensorsUrl: 'http://10.1.131.13:8106/sa',
        wxWorkAppId: 'ww33c91e748f1f38e4',
        wxWorkAgentId: '1000012',
    }
}

export const getEnvData = (key) => {
    if (key) {
        return envData[env][key]
    }
    return false
}



// WEBPACK FOOTER //
// ./src/utils/env.js